/* eslint-disable no-undef */

import {
  GET_CREDIT_CARD_URL,
  KONDUTO_URL,
  POSITIVE_CONSUMER_URL,
  RIGHT_DEAL_URL
} from '@/constants/links'

const URL_PARAMETERS = '&utm_placement=header'

const isOrganic = NEXT_PUBLIC_BUILD_TYPE === 'organic'

const ORGANIC_BUSINESS_LINKS = [
  {
    id: 'solutions',
    label: 'Soluções',
    path: `${urlEquifaxOrganic}/solucoes-para-empresas/`
  },
  {
    id: 'prepaid',
    label: 'Recarga Pré-Pago',
    path: `${urlEquifaxOrganic}/consultas-pre-pago/`
  },
  {
    id: 'antifraud',
    target: '_blank',
    label: 'Antifraude',
    path: KONDUTO_URL
  }
]

const PAID_BUSINESS_LINKS = [
  {
    id: 'products',
    label: 'Produtos',
    children: [
      {
        id: 'negativation',
        label: 'Negativação',
        path: '/produtos/negativacao/'
      }
    ]
  },
  {
    id: 'segments',
    label: 'Segmentos',
    children: [
      {
        id: 'civilConstruction',
        label: 'Construção civil',
        path: '/segmentos/construcao-civil/'
      }
    ]
  }
]

export const BUSINESS_LINKS = [
  {
    id: 'plans',
    label: 'Planos Pós-Pago',
    path: basePath
  },
  {
    id: 'selfConsult',
    label: 'Consulte seu CNPJ grátis',
    path: `${basePath}consultar-meu-cnpj/`
  },
  {
    id: 'cadastral',
    label: 'Consulta cadastral',
    path: `${basePath}consulta-cadastral/`
  },
  ...(isOrganic ? ORGANIC_BUSINESS_LINKS : PAID_BUSINESS_LINKS)
]

export const CONSUMER_LINKS = [
  {
    id: 'score',
    target: '_blank',
    label: 'Monitorar score',
    path: `${POSITIVE_CONSUMER_URL}${URL_PARAMETERS}`
  },
  {
    id: 'negotiateDebts',
    target: '_blank',
    label: 'Negociar dívidas',
    path: `${RIGHT_DEAL_URL}${URL_PARAMETERS}`
  },
  {
    id: 'positiveConsumer',
    target: '_blank',
    label: 'Consultar CPF',
    path: `${POSITIVE_CONSUMER_URL}${URL_PARAMETERS}`
  },
  {
    id: 'getLoan',
    target: '_blank',
    label: 'Buscar empréstimo',
    path: `${GET_CREDIT_CARD_URL}${URL_PARAMETERS}`
  }
]
